import { useState, useEffect, useContext, useRef, useCallback } from "react";

import ReactFlow, {
  addEdge,
  Background,
  Controls,
  MiniMap,
  updateEdge,
  useEdgesState,
  useNodesState,
} from "reactflow";
import "reactflow/dist/style.css";
import { useToast } from "@chakra-ui/react";
import ReactTimeAgo from "react-time-ago";
import { Divider } from "@chakra-ui/react";
import { Url } from '../store/global';

import {
  Flex,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  Text,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverArrow,
  PopoverCloseButton,
  Select,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Tag,
  useDisclosure,
  Spinner,
  Icon,
  Slider,
  SliderTrack,
  SliderFilledTrack,
  SliderThumb,
  Box,
  Tooltip,
  InputGroup,
  InputLeftElement,
  Textarea,
  Avatar,
  Spacer,
} from "@chakra-ui/react";
import { ChevronDownIcon, SearchIcon } from "@chakra-ui/icons";

import AuthContext from "../store/auth";
import Sidebar from "../components/Sidebar";
import { useParams } from "react-router-dom";
import swal from "sweetalert";
import {
  BsPencilFill,
  BsTrash,
  BsPencilSquare,
  BsFillFolderFill,
  BsFillReplyFill,
  BsReply,
  BsChatLeftFill,
  BsChatLeft,
} from "react-icons/bs";
import Rating from "../components/Rating";
import { BiPencil, BiTrash } from "react-icons/bi";
import SearchInArray from "../components/SearchInArray";
import { useHotkeys } from "react-hotkeys-hook";
import Breadcrumbs from "../components/BreadCrumbs";
import { ReactSearchAutocomplete } from "react-search-autocomplete";

const initialNodes = [];

const initialEdges = [];

const Template = () => {
  const toast = useToast();
  const authCtx = useContext(AuthContext);
  let { templateSlug } = useParams();

  const [captureElementClick] = useState(true);

  const [nodes, setNodes] = useState(initialNodes);
  const [edges, setEdges] = useState(initialEdges);

  const [search, setSearch] = useState("");

  const [projectInfo, setProjectInfo] = useState();
  const [loadMore, setLoadMore] = useState(false);
  const [isCollab, setIsCollab] = useState(true);
  const [isOwner, setIsOwner] = useState(false);
  const [collabs, setCollabs] = useState(null);
  const [reviews, setReviews] = useState(null);
  const [replies, setReplies] = useState([[]]);

  const [uc, setuc] = useState(0);
  const [netRating, setNetRating] = useState(0);
  const [clients, setClients] = useState(null);
  const [dropdown, setDropdown] = useState();
  const [accessList, setAccessList] = useState();
  const [hasAccessList, setHasAccessList] = useState();
  const [isOpen7, setIsOpen7] = useState(true);
  const [id, setId] = useState(0);
  const [dropdownCollaborators, setDropdownCollaborators] = useState();
  const [dropdownViewers, setDropdownViewers] = useState();
  const [dropdownClients, setDropdownClients] = useState();
  const [blocksSearch, setBlocksSearch] = useState([]);

  const [selectedRole, setSelectedRole] = useState("Select Role");

  const [hoveredNode, setHoveredNode] = useState(null);
  const onNodeClick = (event, node) => {
    window.location = "/page/" + node.id;
  };
  const onNodeMouseEnter = (event, node) => {
    setHoveredNode(node);
  };
  const onNodeMouseLeave = (event, node) => {
    setHoveredNode(null);
    // hoveredNode.current = node;
  };
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isOpen2,
    onOpen: onOpen2,
    onClose: onClose2,
  } = useDisclosure();
  const {
    isOpen: isOpenReply,
    onOpen: onOpenReply,
    onClose: onCloseReply,
  } = useDisclosure();

  const {
    isOpen: isOpenReplyShow,
    onOpen: onOpenReplyShow,
    onClose: onCloseReplyShow,
  } = useDisclosure();

  const {
    isOpen: isOpen4,
    onOpen: onOpen4,
    onClose: onClose4,
  } = useDisclosure();

  const {
    isOpen: isOpen5,
    onOpen: onOpen5,
    onClose: onClose5,
  } = useDisclosure();
  const {
    isOpen: isOpen6,
    onOpen: onOpen6,
    onClose: onClose6,
  } = useDisclosure();

  const {
    isOpen: isOpenAccess,
    onOpen: onOpenAccess,
    onClose: onCloseAccess,
  } = useDisclosure();

  const accessHandler = (e) => {
    if (selectedRole === "Viewer") {
      viewerHandler();
    } else if (selectedRole === "Collaborator") {
      collabHandler();
    } else if (selectedRole === "Client") {
      clientHandler();
    } else if (selectedRole === "Owner") {
      newOwnerHandler();
    }
    setSelectedRole("Select Role");
  };

  const newOwner = useRef();
  const emailA = useRef();
  const emailView = useRef();

  const [title, setTitle] = useState();
  const [industry, setIndustry] = useState();
  const [client, setClient] = useState();
  const [visibility, setVisibility] = useState();
  const [code, setCode] = useState();
  const [sliderValue, setSliderValue] = useState(
    JSON.parse(window.localStorage.getItem("zoomSlider"))
      ? JSON.parse(window.localStorage.getItem("zoomSlider"))
      : 0
  );
  const [showTooltip, setShowTooltip] = useState(false);

  const openInNewTab = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  // const [rating,setRating]=useState(0);
  const logoutHandler = () => {
    authCtx.logout();
  };

  const [stateDescription, setStateDescription] = useState("");

  const handleDescriptionChange = (event) => {
    setStateDescription(event.target.value);
  };

  const onConnect = useCallback((params) => {
    setEdges((eds) => addEdge(params, eds));
    linkPage(params.target, params.source);
  }, []);

  // delete edges
  const edgeUpdateSuccessful = useRef(true);
  const onEdgeUpdateStart = useCallback(() => {
    edgeUpdateSuccessful.current = false;
  }, []);

  const onEdgeUpdate = useCallback((oldEdge, newConnection) => {
    edgeUpdateSuccessful.current = true;
    // setEdges((els) => updateEdge(oldEdge, newConnection, els))
    // console.log(newConnection,oldEdge);
    // const myPromise = new Promise((resolve, reject) => {
    //     if(newConnection.source !== oldEdge.source && newConnection.target === oldEdge.target)
    //     {
    //       resolve(deleteLink("this_page_depends_on",oldEdge.source, oldEdge.target));
    //     }
    //   else if(newConnection.source === oldEdge.source && newConnection.target !== oldEdge.target)
    //     {
    //       console.log("here");
    //       resolve(deleteLink("this_page_depends_on",oldEdge.source, oldEdge.target));
    //     }

    // });

    // myPromise.then(()=>{
    // console.log(newConnection,oldEdge);
    // linkPage(newConnection.source, newConnection.target)
    // });

    // ;
  }, []);

  const linkPage = (child, parent) => {
    fetch({Url}.Url+"/link_pages/", {
      method: "POST",
      body: JSON.stringify({
        page_id: child,
        depends_on: parent,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: "Token " + authCtx.token,
      },
    }).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            getProjectInformation();
            // console.log(res.data);
          } else {
            toast({
              title: "Something went wrong!",
              description: res.data.detail,
              status: "error",
              duration: 2000,
              isClosable: true,
            });

            // swal("Something went wrong!", res.data.detail, "error");
          }
        })
    );
  };
  const deleteLink = (type, child, parent) => {
    fetch({Url}.Url+"/delete_page_links/", {
      method: "POST",
      body: JSON.stringify({
        type: type,
        page_id: parent,
        deleted_id: child,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: "Token " + authCtx.token,
      },
    }).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            getProjectInformation();
            // console.log(res.data);
          } else {
            toast({
              title: "Something went wrong!",
              description: res.data.detail,
              status: "error",
              duration: 2000,
              isClosable: true,
            });
            // swal("Oops, something went wrong!", res.data.detail, "error");
          }
        })
    );
  };

  const onEdgeUpdateEnd = useCallback((_, edge) => {
    if (!edgeUpdateSuccessful.current) {
      setEdges((eds) => eds.filter((e) => e.id !== edge.id));
      deleteLink("this_page_depends_on", edge.source, edge.target);
    }

    edgeUpdateSuccessful.current = true;
  }, []);

  const currRating = useRef(0);
  const currID = useRef(0);
  const currDesc = useRef("");
  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };
  const {
    isOpen: isOpen3,
    onOpen: onOpen3,
    onClose: onClose3,
  } = useDisclosure();
  const getProjectInformation = () => {
    fetch({Url}.Url+"/flowchart/" + templateSlug + "/", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Token " + authCtx.token,
      },
    }).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            // console.log(res.data);
            setProjectInfo(res.data.project);
            setNodes(res.data.initialNodes);
            setEdges(res.data.initialEdges);
            setIsCollab(res.data.is_collaborator);
            setIsOwner(res.data.is_owner);
            setTitle(res.data.project.title);
            setIndustry(res.data.project.industry);
            setClient(res.data.project.client_name);
            setVisibility(res.data.project.visibility);
            setCode(
              res.data.project.project_code ? res.data.project.project_code : ""
            );
            setStateDescription(res.data.project.description);
            setDropdown(res.data.dropdown_list);
            setBlocksSearch(
              res.data.initialNodes.map(({ id, data }) => {
                let { label } = data;
                label = label.replace("🆕", "").replace("📝", "");
                // trim starting and ending characters
                label = label.trim();
                id = parseInt(id);
                return { id, name: label };
              })
            );
          } else {
            toast({
              title: "Something went wrong!",
              description: res.data.detail,
              status: "error",
              duration: 2000,
              isClosable: true,
            });
            // swal("Oops, something went wrong!", res.data.detail, "error");
          }
        })
    );
  };

  function deleteHandler(projectID) {
    // console.log(projectID);
    fetch({Url}.Url+"/deleted_projects/", {
      method: "DELETE",
      body: JSON.stringify({
        project_id: projectID.toString(),
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: "Token " + authCtx.token,
      },
    }).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            // console.log(res.data);
            toast({
              title: "Deletion confirmed.",
              description: "Let's head back to templates library.",
              status: "success",
              duration: 2000,
              isClosable: true,
              onCloseComplete: () => {
                window.location = "/templates";
              },
            });
            // swal(
            //   "Deletion confirmed.",
            //   "Let's head back to templates library.",
            //   "success",{timer:2000}
            // ).then(() => (window.location = "/templates"));
          } else {
            // console.log(res.data);
            toast({
              title: "Deleting failed.",
              description: res.data.detail,
              status: "error",
              duration: 2000,
              isClosable: true,
            });
            // swal("Deleting failed.", res.data.detail, "error");
          }
        })
    );
  }
  // function to copy a project
  function copyTemplateHandler() {
    fetch(
      {Url}.Url+"/copy_project/" + templateSlug + "/",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + authCtx.token,
        },
      }
    ).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            toast({
              title: "Template cloned successfully!",
              description: "Let's head to the project.",
              status: "success",
              duration: 2000,
              isClosable: true,
              onCloseComplete: () => {
                window.location = "/project/" + res.data.new_project_id + "/";
              },
            });
            // swal(
            //   "Template cloned successfully!",
            //   "Let's head to the project.",
            //   "success"
            // ).then(() => {
            //   window.location = "/project/" + res.data.new_project_id + "/";
            // });
          } else {
            toast({
              title: "Cloning failed.",
              description: res.data.detail,
              status: "error",
              duration: 2000,
              isClosable: true,
            });
            // swal("Cloning failed.", res.data.detail, "error");
          }
        })
    );
  }

  function postReplies(search, id) {
    console.log(authCtx);
    fetch({Url}.Url+"/template_replies/" + id + "/", {
      method: "POST",
      body: JSON.stringify({
        comment: search,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: "Token " + authCtx.token,
      },
    }).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            // console.log(res.data);
            console.log(res);
            toast({
              title: "Reply Added Successfully!",
              description: "Let's head back.",
              status: "success",
              position: "top-right",
              duration: 2000,
              isClosable: true,
              onCloseComplete: () => {
                window.location = "/template/" + templateSlug + "/";
              },
            });
          }
        })
    );
  }

  function getReviews() {
    fetch(
      {Url}.Url+"/template_reviews/" +
        templateSlug +
        "/",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + authCtx.token,
        },
      }
    ).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            // console.log(res.data);
            setReviews(res.data);
            // setReplies(res.data.replies);
            console.log(res.data);
            setNetRating(() => {
              let sum = 0;
              res.data.forEach((rev) => {
                sum += rev.rating;
              });
              return sum / res.data.length;
            });
          }
        })
    );
  }

  useEffect(() => {
    reviews?.forEach((rating) => {
      if (rating?.author === projectInfo?.project_owner) {
        currRating.current = rating.rating;
        currDesc.current = rating.comment;
        currID.current = rating.id;
      }
    }, []);
  }, [projectInfo]);

  useEffect(() => {
    reviews?.forEach((rating) => {
      if (rating?.id === id) {
        setReplies(rating.replies[0]);
        console.log(replies);
      }
    }, []);
  }, [id]);

  const nodeColor = (node) => {
    switch (node.style.backgroundColor) {
      case "#984444":
        return "#ff0072";
      case "#2C6D3E":
        return "#6ede87";
      default:
        return "#5c6e7a ";
    }
  };

  useEffect(() => {
    getCollabs();
    getClients();
    getAccess();

    // getViewers();
    // getFolders();
    // eslint-disable-next-line
  }, [uc]);

  const requestCollabAccess = () => {
    fetch(
      {Url}.Url+"/request_collaboration/" +
        templateSlug +
        "/",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + authCtx.token,
        },
      }
    ).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            toast({
              title: "Collaboration Request sent successfully!",
              description: "Let's continue working.",
              status: "success",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });
            // swal(
            //   "Collaboration Request sent successfully!",
            //   "Let's continue working.",
            //   "success"
            // );
          } else {
            toast({
              title: "Something went wrong!",
              description: res.data.detail,
              status: "error",
              duration: 2000,
              isClosable: true,
            });
            // swal("Oops, something went wrong!", res.data.detail, "error");
          }
        })
    );
  };

  const handleSlider = (value) => {
    // console.log(value);
    setSliderValue(value);
    switch (value) {
      case 0: {
        fontChangeHandler(150, 10);
        break;
      }
      case 20: {
        fontChangeHandler(167, 14);

        break;
      }
      case -20: {
        fontChangeHandler(150, 9);
        break;
      }
      case 40: {
        fontChangeHandler(182, 17);
        break;
      }
      case -40: {
        fontChangeHandler(150, 7);
        break;
      }
      case 60: {
        fontChangeHandler(195, 20);
        break;
      }
      default: {
        break;
      }
    }
  };

  const fontChangeHandler = (width, value) => {
    if (nodes && nodes[0].style) {
      setNodes(
        nodes.map((node) => {
          node.style = {
            ...node.style,
            fontSize: value,
            width: width,
          };
          return node;
        })
      );
    }
  };

  const reviewHandler = (type, rating, comment) => {
    // console.log(type,rating,comment);
    fetch(
      {Url}.Url+"/template_reviews/" +
        templateSlug +
        "/",
      {
        method: type,
        body: JSON.stringify({
          id: currID.current,
          rating: currRating.current,
          comment: search,
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + authCtx.token,
        },
      }
    ).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            // console.log(res);
            toast({
              title: "Review added successfully!",
              description: "Let's head back.",
              status: "success",
              duration: 2000,
              isClosable: true,
              onCloseComplete: () => {
                window.location = "/template/" + templateSlug + "/";
              },
            });
            // swal(
            //   "Review added successfully!",
            //   "Let's head back.",
            //   "success"
            // ).then(() => {
            //   window.location = "/template/" + templateSlug + "/";
            // });
            // window.location = "/project/" + res.data.project_id;
          } else {
            toast({
              title: "Failed.",
              description: res.data.detail,
              status: "error",
              duration: 2000,
              isClosable: true,
            });
            // swal("Failed.", res.data.detail, "error");
          }
        })
    );
  };
  const newOwnerHandler = () => {
    fetch(
      {Url}.Url+"/change_project_owner/" +
        templateSlug +
        "/",
      {
        method: "POST",
        body: JSON.stringify({
          new_owner: newOwner.current.value,
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + authCtx.token,
        },
      }
    ).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            toast({
              title: "New Owner confirmed.",
              description: "Let's head back to the library.",
              status: "success",
              duration: 2000,
              isClosable: true,
              onCloseComplete: () => {
                window.location = "/library";
              },
            });
            // swal(
            //   "New Owner confirmed.",
            //   "Let's head back to the library.",
            //   "success"
            // ).then(() => {
            //   window.location = "/library";
            // });
          } else {
            toast({
              title: "Something went wrong!",
              description: res.data.detail,
              status: "error",
              duration: 2000,
              isClosable: true,
            });
            // swal("Oops, something went wrong!", res.data.detail, "error");
          }
        })
    );
  };
  const clientRemoveHandler = (email) => {
    let tEmail = email ? email : "";
    fetch(
      {Url}.Url+"/manage_clients/" + templateSlug + "/",
      {
        method: "DELETE",
        body: JSON.stringify({
          clients: tEmail,
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + authCtx.token,
        },
      }
    ).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            toast({
              title: "Client Removed successfully!",
              description: "Let's continue working on this template.",
              status: "success",
              duration: 2000,
              isClosable: true,
            });

            // swal(
            //   "Client Removed successfully!",
            //   "Let's continue working on this template.",
            //   "success"
            // );
            onClose5();
            getClients();
          } else {
            toast({
              title: "Removing Client failed.",
              description: res.data.detail,
              status: "error",
              duration: 2000,
              isClosable: true,
            });
            // swal("Removing Client failed.", res.data.detail, "error");
          }
        })
    );
    // console.log(tEmail)
  };
  const getClients = () => {
    fetch(
      {Url}.Url+"/manage_clients/" + templateSlug + "/",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + authCtx.token,
        },
      }
    ).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            setClients(res.data.added_clients);
            // console.log(res.data);
            setDropdownClients(res.data.not_added_clients);
            // console.log(collabs);
          } else {
            toast({
              // title:'Removing Client failed.',
              description: "Something went wrong.",
              status: "error",
              duration: 2000,
              isClosable: true,
            });
            // swal(
            //   // "Adding clients failed.",
            //   "Something went wrong.",
            //   "error"
            // );
          }
        })
    );
  };

  const deleteReview = (id) => {
    // console.log(type,rating,comment);
    fetch(
      {Url}.Url+"/template_reviews/" +
        templateSlug +
        "/",
      {
        method: "DELETE",
        body: JSON.stringify({
          id: id,
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + authCtx.token,
        },
      }
    ).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            // console.log(res);
            toast({
              title: "Review deleted successfully!",
              description: "Let's head back.",
              status: "success",
              duration: 2000,
              isClosable: true,
              onCloseComplete: () => {
                window.location = "/template/" + templateSlug + "/";
              },
            });

            // swal(
            //   "Review deleted successfully!",
            //   "Let's head back.",
            //   "success"
            // ).then(() => {
            //   window.location = "/template/" + templateSlug + "/";
            // });
            // window.location = "/project/" + res.data.project_id;
          } else {
            toast({
              title: "Failed to delete",
              description: res.data.detail,
              status: "error",
              duration: 2000,
              isClosable: true,
            });

            // swal("Failed to delete", res.data.detail, "error");
          }
        })
    );
  };
  const collabHandler = () => {
    fetch(
      {Url}.Url+"/manage_collaborators/" +
        templateSlug +
        "/",
      {
        method: "POST",
        body: JSON.stringify({
          collaborators: emailA.current.value,
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + authCtx.token,
        },
      }
    ).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            toast({
              title: "Collaborators added successfully!",
              description: "Let's continue working on this template.",
              status: "success",
              duration: 2000,
              isClosable: true,
            });
            // swal(
            //   "Collaborators added successfully!",
            //   "Let's continue working on this template.",
            //   "success"
            // );
            onClose4();
            setuc(uc + 1);
          } else {
            toast({
              title: "Adding collaborators failed.",
              description: res.data.detail,
              status: "error",
              duration: 2000,
              isClosable: true,
            });
            // swal("Adding collaborators failed.", res.data.detail, "error");
          }
        })
    );
  };

  const getCollabs = () => {
    fetch(
      {Url}.Url+"/manage_collaborators/" +
        templateSlug +
        "/",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + authCtx.token,
        },
      }
    ).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            setCollabs(res.data.collaborators);
            setDropdownCollaborators(res.data.not_collaborators);
            // console.log(collabs);
          } else {
            toast({
              title: "Adding collaborators failed.",
              description: "Something went wrong.",
              status: "error",
              duration: 2000,
              isClosable: true,
            });
            // swal(
            //   "Adding collaborators failed.",
            //   "Something went wrong.",
            //   "error"
            // );
          }
        })
    );
  };
  const viewerHandler = () => {
    fetch(
      {Url}.Url+"/manage_viewers/" + templateSlug + "/",
      {
        method: "POST",
        body: JSON.stringify({
          viewers: emailView.current.value,
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + authCtx.token,
        },
      }
    ).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            toast({
              title: "Viewers added successfully!",
              description: "Let's continue working on this template.",
              status: "success",
              duration: 2000,
              isClosable: true,
            });
            // swal(
            //   "Viewers added successfully!",
            //   "Let's continue working on this template.",
            //   "success"
            // );
            onClose4();
            setuc(uc + 1);
          } else {
            toast({
              title: "Adding viewers failed.",
              description: res.data.detail,
              status: "error",
              duration: 2000,
              isClosable: true,
            });
            // swal("Adding viewers failed.", res.data.detail, "error");
          }
        })
    );
  };

  const clientHandler = () => {
    fetch(
      {Url}.Url+"/manage_clients/" + templateSlug + "/",
      {
        method: "POST",
        body: JSON.stringify({
          clients: emailView.current.value,
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + authCtx.token,
        },
      }
    ).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            toast({
              title: "Clients added successfully!",
              description: "Let's continue working on this template.",
              status: "success",
              duration: 2000,
              isClosable: true,
            });
            // swal(
            //   "Clients added successfully!",
            //   "Let's continue working on this template.",
            //   "success"
            // );
            onClose5();
            setuc(uc + 1);
          } else {
            toast({
              title: "Adding viewers failed.",
              description: res.data.detail,
              status: "error",
              duration: 2000,
              isClosable: true,
            });
            // swal("Adding viewers failed.", res.data.detail, "error");
          }
        })
    );
  };
  const collabRemoveHandler = (email) => {
    // let tEmail = email
    //   ? email.substring(email.indexOf("<") + 1, email.indexOf(">"))
    //   : "";
    fetch(
      {Url}.Url+"/manage_collaborators/" +
        templateSlug +
        "/",
      {
        method: "DELETE",
        body: JSON.stringify({
          collaborators: email,
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + authCtx.token,
        },
      }
    ).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            toast({
              title: "Clients removed successfully!",
              description: "Let's continue working on this template.",
              status: "success",
              duration: 2000,
              isClosable: true,
            });
            // swal(
            //   "Collaborator Removed successfully!",
            //   "Let's continue working on this template.",
            //   "success"
            // );
            onClose4();
            getAccess();
            getCollabs();
          } else {
            toast({
              title: "Removing collaborator failed.",
              description: res.data.detail,
              status: "error",
              duration: 2000,
              isClosable: true,
            });
            // swal("Removing collaborator failed.", res.data.detail, "error");
          }
        })
    );
    // console.log(tEmail)
  };
  function ratingHandler(r) {
    currRating.current = r;
    // console.log(rating)
  }

  // nodes && console.log(nodes);
  // runs on initial page load
  useEffect(() => {
    getProjectInformation();
    getCollabs();
    getClients();
    getAccess();

    getReviews();
    // getViewers();
    // setProjectInfo(data.project);
    // setNodes(data.initialNodes);
    // setEdges(data.initialEdges);
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    window.localStorage.setItem("zoomSlider", JSON.stringify(sliderValue));
    // console.log(sliderValue)
  }, [sliderValue]);

  useEffect(() => {
    nodes.length > 0 && handleSlider(sliderValue);
  }, [edges]);

  // autocomplete search implementation
  const handleOnSearch = (string, results) => {
    // onSearch will have as the first callback parameter
    // the string searched and for the second the results.
    // console.log(string, results);
  };

  const handleOnHover = (result) => {
    // the item hovered
    // console.log(result);
  };

  const handleOnSelect = (item) => {
    // the item selected
    // console.log(item);
    window.location = "/page/" + item.id;
  };

  const handleOnFocus = () => {
    // console.log("Focused");
  };

  const formatResult = (item) => {
    // console.log(item);
    return (
      <div className="result-wrapper">
        <span className="result-span">id: {item.id}</span>
        <span className="result-span">name: {item.name}</span>
      </div>
    );
  };
  // search
  const searchOnClickHandler = (e) => {
    e();
  };

  var loadMoreFunc = () => {
    if (loadMore) setLoadMore(false);
    else setLoadMore(true);
    console.log(loadMore);
  };

  const editProjectHandler2 = () => {
    onOpen2();
  };

  const editProjectHandler = () => {
    // console.log(visibility);
    fetch(
      {Url}.Url+"/edit_project/" + templateSlug + "/",
      {
        method: "POST",
        body: JSON.stringify({
          title: title,
          industry: industry,
          client_name: client,
          project_code: code,
          description: stateDescription,
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + authCtx.token,
        },
      }
    ).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            // console.log(res.data);
            toast({
              title: "Project Edited successfully!.",
              description: "Let's head back.",
              status: "success",
              duration: 2000,
              isClosable: true,
            });
            // swal(
            //   "Project Edited successfully!.",
            //   "Let's head back.",
            //   "success",
            //   { timer: 2000 }
            // );
            window.location.reload();
          } else {
            // console.log(res.data);
            toast({
              title: "Project editing failed.",
              description: res.data.detail,
              status: "error",
              duration: 2000,
              isClosable: true,
            });
            // swal("Project editing failed.", res.data.detail, "error", {
            //   timer: 2000,
            // });
          }
        })
    );
  };

  const getAccess = () => {
    fetch(
      {Url}.Url+"/manage_access/" + templateSlug + "/",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + authCtx.token,
        },
      }
    ).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            // console.log(res.data);
            setAccessList(
              res.data.not_access.map(({ email }, id) => {
                // let { label } = data;
                // trim starting and ending characters
                id = parseInt(id);
                // return { id, name: data };
                return { id: id, name: email };
              })
            );
            setHasAccessList(res.data.has_access);
            // console.log(res.data.has_access);
            // console.log(accessList)
          }
        })
    );
  };
  useHotkeys("alt+x", () => (window.location = "/templates"));
  useHotkeys("option+x", () => (window.location = "/templates"));
  useHotkeys("alt+c", () => copyTemplateHandler());
  useHotkeys("option+c", () => copyTemplateHandler());
  useHotkeys("alt+n", () => openInNewTab("/new-page/" + templateSlug));
  useHotkeys("option+n", () => openInNewTab("/new-page/" + templateSlug));
  const breadcrumbs = [{ path: "/", breadcrumb: "Home" }];

  return (
    <>
      <Flex
        backgroundColor="bg"
        flexDir="column"
        alignItems="center"
        width="100vw"
      >
        <Flex
          width={{ base: "97%", md: "98%" }}
          height="fit-content"
          flexDir="column"
          justifyContent="space-between"
        >
          {projectInfo ? (
            <>
              {/* {isOwner ? (
              <Sidebar>
                {isCollab ? (
                  <Flex
                    // mt="100px"
                    width="100%"
                    my={2}
                    mt={10}
                    // height="fit-content"
                    flexDir="column"
                    justifyContent="space-between"
                    // alignItems=""
                    pl="10px"
                    height="100%"
                    position="relative"
                    zIndex="10"
                    // backgroundColor="#2A3843"
                  >
                    <Flex flexDir="column" align={"left"}>
                      <Button
                        bg="#444d54"
                        justifyContent={"left"}
                        width="90% "
                        color="white"
                        fontSize="14px"
                        _hover={{
                          background: "#F2DBA6",
                        }}
                        // mr="10px"
                        autoFocus
                        onClick={onOpen4}
                      >
                        Manage collaborators
                      </Button>
                      <Button
                        bg="#444d54"
                        justifyContent={"left"}
                        width="90% "
                        color="white"
                        fontSize="14px"
                        _hover={{
                          background: "#F2DBA6",
                        }}
                        mr="10px"
                        onClick={onOpen5}
                      >
                        Manage clients
                      </Button>
                      {isOwner ? (
                        <Button
                          bg="#444d54"
                          width="90%"
                          justifyContent={"left"}
                          color="white"
                          fontSize="14px"
                          _hover={{
                            background: "#F2DBA6",
                          }}
                          mr="10px"
                          onClick={onOpen3}
                        >
                          Change Owner
                        </Button>
                      ) : null}
                      {isOwner ? (
                        <Button
                          bg="#444d54"
                          width="90%"
                          justifyContent={"left"}
                          color="white"
                          fontSize="14px"
                          _hover={{
                            background: "#F2DBA6",
                          }}
                          // mr="10px"
                          onClick={copyTemplateHandler}
                        >
                          Use this template
                        </Button>
                      ) : null}
                        <Flex
                          dir="row"
                          justifyContent={"left"}
                          width="90%"
                          p={2}
                          >
                          {isOwner ? (
                          <Button
                            bg="#444d54"
                            // width="35px"
                            p="2px"
                            mb={["20px", "20px", "20px", "0px", "0px"]}
                            color="white"
                            fontSize="14px"
                            onClick={() =>
                              openInNewTab(
                                "/trash-blocks/" + templateSlug + "/"
                              )
                            }
                            _hover={{
                              background: "#F2DBA6",
                            }}
                            mr="10px"
                          >
                            <Icon
                              as={BsTrash}
                              margin="auto"
                              color="white"
                              mr="10px"
                              />
                          </Button>
                              ) : null}
                              <Flex justifyContent={"left"} width="90%">
                                <SearchInArray
                                  message={"Search in blocks"}
                                  items={blocksSearch}
                                  handleOnClick={searchOnClickHandler}
                                  handleOnSearch={handleOnSearch}
                                  handleOnSelect={handleOnSelect}
                                  handleOnFocus={handleOnFocus}
                                  handleOnHover={handleOnHover}
                                />
                              </Flex>
                        </Flex>
                      <Flex
                        flexDir="column"
                        // width="100%"
                        // bottom="0"
                        // mt={["20px", "20px", "50px", "50px", "50px"]}
                        cursor="pointer"
                        mx="10px"
                        mb="10px"
                        position={"absolute"}
                        bottom="0"
                      >
                        {isOwner ? (
                          <Popover>
                            <PopoverTrigger>
                              <Button
                                colorScheme="red"
                                // width="100%"
                                maxW="80%"
                                minW="220px"
                                mt="10px"
                                fontSize="14px"
                              >
                                Delete this Template
                              </Button>
                            </PopoverTrigger>
                            <PopoverContent bg="grey3" color="white">
                              <PopoverArrow />
                              <PopoverCloseButton />
                              <PopoverHeader>Confirmation!</PopoverHeader>
                              <PopoverBody>
                                <Text>Are you sure about this?</Text>
                                <Button
                                  colorScheme="red"
                                  width="160px"
                                  height="40px"
                                  p="10px"
                                  fontSize="14px"
                                  mr="10px"
                                  mt="20px"
                                  onClick={() => deleteHandler(projectInfo?.id)}
                                >
                                  Delete permanently
                                </Button>
                              </PopoverBody>
                            </PopoverContent>
                          </Popover>
                        ) : null}
                        <Flex bottom={0} my={2} width="80%">
                          <Button
                            bg="#4B555E"
                            maxW="80%"
                            minW="220px"
                            p={2}
                            color="white"
                            fontSize="14px"
                            // mr="10px"
                            as="a"
                            href={"/new-page/" + templateSlug}
                          >
                            Add a New Block
                          </Button>
                        </Flex>
                      </Flex>
                    </Flex>
                  </Flex>
                ) : null}
              </Sidebar>
            ) : (
              <Sidebar>
                <Flex
                  // mt="100px"
                  width="100%"
                  my={2}
                  // height="fit-content"
                  flexDir="column"
                  // justifyContent="space-between"
                  // alignItems=""
                  ml={4}
                  mt={4}
                  // backgroundColor="#2A3843"
                >
                  {authCtx.role !== "Client" && (
                    <Button
                      cursor="pointer"
                      bg="#4B555E"
                      // maxW="100%"
                      // minW="220px"
                      width="85%"
                      color="white"
                      fontSize="14px"
                      p={2}
                      _hover={{
                        background: "#F2DBA6",
                      }}
                      onClick={requestCollabAccess}
                    >
                      Request Collaboration Access
                    </Button>
                  )}
                  <Flex justifyContent={"left"} width="90%" py={2}>
                    <SearchInArray
                      message={"Search in blocks"}
                      items={blocksSearch}
                      handleOnClick={searchOnClickHandler}
                      handleOnSearch={handleOnSearch}
                      handleOnSelect={handleOnSelect}
                      handleOnFocus={handleOnFocus}
                      handleOnHover={handleOnHover}
                    />
                  </Flex>
                </Flex>
                <Flex
                  flexDir="column"
                  cursor="pointer"
                  alignItems={"center"}
                  // mx="10px"
                  mb="10px"
                  position={"absolute"}
                  bottom="10px"
                  width="100%"
                >
                  <Button
                    bg="yellow1"
                    width="90%"
                    // maxW="0%"
                    color="white"
                    // minW="220px"
                    p={2}
                    mt="10px"
                    my={2}
                    fontSize="14px"
                    onClick={() => copyTemplateHandler()}
                  >
                    Use this template
                  </Button>
                  <Button
                    bg="#4B555E"
                    // maxW="80%"
                    // minW="220px"
                    width="90%"
                    p={2}
                    color="white"
                    fontSize="14px"
                    // mr="10px"
                    as="a"
                    onClick={onOpen}
                  >
                    Add review
                  </Button>
                </Flex>
              </Sidebar>
            )} */}
              <Flex
                width={["99%", "99%", "100%", "100%", "100%"]}
                flexDir="column"
                mr="10px"
              >
                <Flex
                  flexDir={{ base: "column", md: "row" }}
                  justifyContent={{ md: "space-between" }}
                  alignItems={{ md: "center" }}
                  borderBottom="2px solid  rgba(255, 255, 255, 0.24)"
                >
                  <Flex flexDir="column" width="100%" mt={2}>
                    <Flex
                      flexDir={"row"}
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Flex
                        w="100%"
                        color="white"
                        fontWeight="400"
                        alignItems="center"
                        justifyContent={"start"}
                      >
                        {projectInfo && (
                          <Breadcrumbs breadcrumbs={breadcrumbs} />
                        )}
                        <Flex
                          flexDir="row"
                          alignItems="center"
                          justifyContent="space-between"
                        >
                          <Text
                            color="background.yellow"
                            fontSize={{ md: "20px" }}
                            fontWeight="900"
                          >
                            Template: {projectInfo.title}
                          </Text>
                          {isOwner || isCollab ? (
                            <Text onClick={onOpen6} cursor="pointer" ml="10px">
                              <svg
                                width="18"
                                height="20"
                                viewBox="0 0 22 27"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M20.393 6.868C20.897 6.364 21.1743 5.69467 21.1743 4.98267C21.1743 4.27067 20.897 3.60133 20.393 3.09733L18.2783 0.982665C17.7743 0.478665 17.105 0.201332 16.393 0.201332C15.681 0.201332 15.0117 0.478665 14.509 0.981332L0.333008 15.1133V21H6.21701L20.393 6.868ZM16.393 2.868L18.509 4.98133L16.389 7.09333L14.2743 4.98L16.393 2.868ZM2.99967 18.3333V16.22L12.3863 6.86266L14.501 8.97733L5.11567 18.3333H2.99967ZM0.333008 23.6667H21.6663V26.3333H0.333008V23.6667Z"
                                  fill="#FFC949"
                                />
                              </svg>
                            </Text>
                          ) : null}
                        </Flex>

                        {/* {isOwner || isCollab ? (
                    <Icon
                      as={BsPencilFill}
                      color="white"
                      onClick={editProjectHandler2}
                      cursor="pointer"
                      ml="10px"
                    />
                  ) : null} */}
                      </Flex>
                      {authCtx.role !== "Client" && (isCollab || isOwner) && (
                        <Flex
                          flexDir={{ md: "column" }}
                          alignItems={{ md: "end" }}
                        >
                          <Flex>
                            {isOwner && (
                              // <MenuItem onClick={deleteHandler}>
                              <Popover>
                                <PopoverTrigger>
                                  <Button
                                    bg="#444d54"
                                    justifyContent={"left"}
                                    color="white"
                                    height="1.9rem"
                                    fontSize={"md"}
                                  >
                                    <BiTrash />
                                  </Button>
                                </PopoverTrigger>
                                <PopoverContent
                                  bg="grey3"
                                  color="white"
                                  display="block"
                                >
                                  <PopoverArrow />
                                  <PopoverCloseButton />
                                  <PopoverHeader>Confirmation!</PopoverHeader>
                                  <PopoverBody display="block">
                                    <Text>This action cannot be undone!</Text>
                                    <Button
                                      colorScheme="red"
                                      width="170px"
                                      height="40px"
                                      p="10px"
                                      fontSize="16px"
                                      mr="10px"
                                      mt="20px"
                                      onClick={() =>
                                        deleteHandler(templateSlug)
                                      }
                                    >
                                      Delete forever?
                                    </Button>
                                  </PopoverBody>
                                </PopoverContent>
                              </Popover>
                              // </MenuItem>
                            )}

                            <Button
                              mx={1}
                              bg="#444d54"
                              justifyContent={"left"}
                              color="white"
                              fontSize="13px"
                              _hover={{
                                background: "#F2DBA6",
                              }}
                              height="1.9rem"
                              onClick={onOpenAccess}
                            >
                              <svg
                                width="15"
                                height="14"
                                viewBox="0 0 19 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M11.4528 12.5961C11.4176 12.5612 11.37 12.5416 11.3204 12.5416C11.2708 12.5416 11.2232 12.5612 11.188 12.5961L8.46455 15.3195C7.20361 16.5804 5.07549 16.714 3.6833 15.3195C2.28877 13.925 2.42236 11.7992 3.6833 10.5383L6.40674 7.81482C6.47939 7.74217 6.47939 7.62264 6.40674 7.54998L5.47393 6.61717C5.43869 6.58227 5.3911 6.5627 5.3415 6.5627C5.29191 6.5627 5.24432 6.58227 5.20908 6.61717L2.48564 9.3406C0.502832 11.3234 0.502832 14.532 2.48564 16.5125C4.46846 18.4929 7.67705 18.4953 9.65752 16.5125L12.381 13.789C12.4536 13.7164 12.4536 13.5969 12.381 13.5242L11.4528 12.5961ZM17.5138 1.4867C15.531 -0.496115 12.3224 -0.496115 10.3419 1.4867L7.61611 4.21014C7.58122 4.24538 7.56164 4.29296 7.56164 4.34256C7.56164 4.39215 7.58122 4.43974 7.61611 4.47498L8.54658 5.40545C8.61924 5.4781 8.73877 5.4781 8.81143 5.40545L11.5349 2.68201C12.7958 1.42107 14.9239 1.28748 16.3161 2.68201C17.7106 4.07654 17.5771 6.20232 16.3161 7.46326L13.5927 10.1867C13.5578 10.2219 13.5382 10.2695 13.5382 10.3191C13.5382 10.3687 13.5578 10.4163 13.5927 10.4515L14.5255 11.3844C14.5981 11.457 14.7177 11.457 14.7903 11.3844L17.5138 8.66092C19.4942 6.6781 19.4942 3.46951 17.5138 1.4867ZM12.2989 5.72654C12.2637 5.69165 12.2161 5.67207 12.1665 5.67207C12.1169 5.67207 12.0693 5.69165 12.0341 5.72654L6.72549 11.0328C6.69059 11.068 6.67102 11.1156 6.67102 11.1652C6.67102 11.2148 6.69059 11.2624 6.72549 11.2976L7.65361 12.2258C7.72627 12.2984 7.8458 12.2984 7.91846 12.2258L13.2247 6.91951C13.2974 6.84685 13.2974 6.72732 13.2247 6.65467L12.2989 5.72654Z"
                                  fill="white"
                                />
                              </svg>{" "}
                              &nbsp; Access
                            </Button>

                            <Menu>
                              <MenuButton>
                                <Button
                                  bg="#444d54"
                                  justifyContent={"left"}
                                  color="white"
                                  height="1.9rem"
                                  fontSize="13px"
                                  _hover={{
                                    background: "#F2DBA6",
                                  }}
                                  // mr="10px"
                                >
                                  <svg
                                    width="22"
                                    height="20"
                                    viewBox="0 0 22 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M19.8187 14.2469C18.8226 13.6703 17.6085 13.825 16.7906 14.5469L15.5484 13.8273V10.2719C15.5484 9.90391 15.3515 9.56172 15.0328 9.37891L11.8453 7.54375V5.97109C12.8812 5.61953 13.6265 4.63984 13.6265 3.48438C13.6265 2.03359 12.4523 0.859375 11.0015 0.859375C9.55073 0.859375 8.37651 2.03359 8.37651 3.48438C8.37651 4.63984 9.12183 5.61953 10.1578 5.97109V7.54375L6.97026 9.37891C6.65151 9.56172 6.45464 9.90391 6.45464 10.2719V13.825L5.21245 14.5445C4.39448 13.8227 3.17808 13.668 2.18433 14.2445C0.93042 14.9711 0.503858 16.5742 1.22339 17.8281C1.94526 19.082 3.54136 19.5133 4.79058 18.7891C5.78667 18.2125 6.26011 17.0781 6.04683 16.0047L7.18823 15.3414L10.4835 17.2398C10.6429 17.3313 10.821 17.3781 10.9992 17.3781C11.1773 17.3781 11.3554 17.3313 11.5148 17.2398L14.8078 15.3438L15.9492 16.007C15.7359 17.0781 16.2117 18.2148 17.2054 18.7914C18.4546 19.5156 20.0531 19.0867 20.7726 17.8305C21.4945 16.5742 21.0679 14.9711 19.8187 14.2469ZM4.04526 17.4906C3.91796 17.5644 3.77733 17.6122 3.63148 17.6313C3.48562 17.6505 3.33741 17.6406 3.19538 17.6023C3.05335 17.564 2.92031 17.4979 2.80391 17.408C2.68751 17.318 2.59005 17.2059 2.51714 17.0781C2.20776 16.5414 2.39058 15.8523 2.9273 15.543C3.0546 15.4692 3.19522 15.4214 3.34108 15.4022C3.48694 15.3831 3.63515 15.3929 3.77718 15.4313C3.91921 15.4696 4.05225 15.5357 4.16865 15.6256C4.28505 15.7156 4.38251 15.8277 4.45542 15.9555C4.7648 16.4922 4.58198 17.1812 4.04526 17.4906ZM9.87417 3.48438C9.88018 3.18998 10.0013 2.90968 10.2117 2.7036C10.422 2.49753 10.7047 2.38211 10.9992 2.38211C11.2936 2.38211 11.5763 2.49753 11.7867 2.7036C11.997 2.90968 12.1182 3.18998 12.1242 3.48438C12.1182 3.77877 11.997 4.05907 11.7867 4.26515C11.5763 4.47122 11.2936 4.58664 10.9992 4.58664C10.7047 4.58664 10.422 4.47122 10.2117 4.26515C10.0013 4.05907 9.88018 3.77877 9.87417 3.48438ZM13.8585 13.9422L10.9992 15.5898L8.1398 13.9422V10.6516L10.9992 9.00391L13.8585 10.6516V13.9422ZM19.4812 17.0805C19.1718 17.6172 18.4875 17.8023 17.9531 17.493C17.4187 17.1836 17.2335 16.4945 17.5429 15.9578C17.8523 15.4211 18.5367 15.2359 19.071 15.5453C19.6078 15.8547 19.7906 16.5414 19.4812 17.0805Z"
                                      fill="white"
                                    />
                                  </svg>
                                  &nbsp; More Actions
                                </Button>
                              </MenuButton>

                              <MenuList>
                                <MenuItem onClick={copyTemplateHandler}>
                                  Use this Template
                                </MenuItem>
                                <MenuItem onClick={onOpen6}>
                                  Add to folder
                                </MenuItem>
                                <MenuItem
                                  onClick={() =>
                                    openInNewTab(projectInfo?.drive_link)
                                  }
                                >
                                  View Drive
                                </MenuItem>
                                {/* <MenuItem
                            onClick={() =>
                              (window.location =
                                "/trash-blocks/" + templateSlug + "/")
                            }
                          >
                            View Trash
                          </MenuItem> */}
                                {/* <MenuItem onClick={onOpen3}>Make Template</MenuItem> */}

                                {/* <MenuItem onClick={onOpen}>Add Review</MenuItem> */}
                              </MenuList>
                            </Menu>
                          </Flex>

                          {/* {!isCollab && !isOwner && (
                        <Button
                          cursor="pointer"
                          mx="10px"
                          bottom="0"
                          bg="#4B555E"
                          // maxW="100%"
                          // minW="220px"
                          color="white"
                          fontSize="13px"
                          _hover={{
                            background: "#F2DBA6",
                          }}
                          mr="10px"
                          onClick={requestCollabAccess}
                        >
                          <svg
                            width="15"
                            height="14"
                            viewBox="0 0 19 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M11.4528 12.5961C11.4176 12.5612 11.37 12.5416 11.3204 12.5416C11.2708 12.5416 11.2232 12.5612 11.188 12.5961L8.46455 15.3195C7.20361 16.5804 5.07549 16.714 3.6833 15.3195C2.28877 13.925 2.42236 11.7992 3.6833 10.5383L6.40674 7.81482C6.47939 7.74217 6.47939 7.62264 6.40674 7.54998L5.47393 6.61717C5.43869 6.58227 5.3911 6.5627 5.3415 6.5627C5.29191 6.5627 5.24432 6.58227 5.20908 6.61717L2.48564 9.3406C0.502832 11.3234 0.502832 14.532 2.48564 16.5125C4.46846 18.4929 7.67705 18.4953 9.65752 16.5125L12.381 13.789C12.4536 13.7164 12.4536 13.5969 12.381 13.5242L11.4528 12.5961ZM17.5138 1.4867C15.531 -0.496115 12.3224 -0.496115 10.3419 1.4867L7.61611 4.21014C7.58122 4.24538 7.56164 4.29296 7.56164 4.34256C7.56164 4.39215 7.58122 4.43974 7.61611 4.47498L8.54658 5.40545C8.61924 5.4781 8.73877 5.4781 8.81143 5.40545L11.5349 2.68201C12.7958 1.42107 14.9239 1.28748 16.3161 2.68201C17.7106 4.07654 17.5771 6.20232 16.3161 7.46326L13.5927 10.1867C13.5578 10.2219 13.5382 10.2695 13.5382 10.3191C13.5382 10.3687 13.5578 10.4163 13.5927 10.4515L14.5255 11.3844C14.5981 11.457 14.7177 11.457 14.7903 11.3844L17.5138 8.66092C19.4942 6.6781 19.4942 3.46951 17.5138 1.4867ZM12.2989 5.72654C12.2637 5.69165 12.2161 5.67207 12.1665 5.67207C12.1169 5.67207 12.0693 5.69165 12.0341 5.72654L6.72549 11.0328C6.69059 11.068 6.67102 11.1156 6.67102 11.1652C6.67102 11.2148 6.69059 11.2624 6.72549 11.2976L7.65361 12.2258C7.72627 12.2984 7.8458 12.2984 7.91846 12.2258L13.2247 6.91951C13.2974 6.84685 13.2974 6.72732 13.2247 6.65467L12.2989 5.72654Z"
                              fill="white"
                            />
                          </svg>{" "}
                          &nbsp; Request Collaboration Access
                        </Button>
                      )} */}
                        </Flex>
                      )}
                    </Flex>

                    <Flex flexDir="row" alignItems="center" pb={1}>
                      <Avatar
                        size="xs"
                        bg="white"
                        name={projectInfo?.project_owner.name}
                        src={projectInfo?.project_owner.name}
                        color="#2D3842"
                        fontWeight="700"
                        mr={2}
                      />
                      <Text fontSize="13px" color="white">
                        {projectInfo?.project_owner.name + " "}
                        <Text
                          borderRight="2px solid #FFFFFF3D"
                          display="inline"
                        >
                          &nbsp;
                        </Text>{" "}
                        &nbsp; Last modified{" "}
                        {" " + projectInfo?.last_modified?.split("T")[0]}{" "}
                        <Text
                          borderRight="2px solid #FFFFFF3D"
                          display="inline"
                        >
                          &nbsp;
                        </Text>
                        &nbsp;{" "}
                        {projectInfo?.last_modified
                          ?.split("T")[1]
                          .split(".")[0]
                          .slice(0, 5)}
                        {"  "}
                        &nbsp;
                      </Text>
                    </Flex>
                  </Flex>
                </Flex>

                <Flex
                  width="100%"
                  height="fit-content"
                  flexDir="column"
                  justifyContent="space-between"
                  pt="10px"
                  // mt="20px"
                >
                  {/* <Text color="white" fontWeight="700" fontSize="20px">
                Project Pyramid
              </Text> */}
                  <Flex
                    fontSize={"xl"}
                    color={"gray.400"}
                    justifyContent="space-between"
                  >
                    <Rating
                      rating={netRating}
                      numReviews={reviews?.length}
                      displayReviewCount={true}
                    />
                    {
                      <Flex>
                        {isOpen7 ? (
                          <Button
                            bg="inherit"
                            _hover={{ bg: "inherit" }}
                            color="white"
                            fontSize="14px"
                            // mr="10px"
                            onClick={() => setIsOpen7(!isOpen7)}
                          >
                            <svg
                              fill="none"
                              viewBox="0 0 15 15"
                              height="1em"
                              width="1em"
                            >
                              <path
                                fill="white"
                                fillRule="evenodd"
                                d="M12.854 2.854a.5.5 0 00-.708-.708L7.5 6.793 2.854 2.146a.5.5 0 10-.708.708L6.793 7.5l-4.647 4.646a.5.5 0 00.708.708L7.5 8.207l4.646 4.647a.5.5 0 00.708-.708L8.207 7.5l4.647-4.646z"
                                clipRule="evenodd"
                              />
                            </svg>
                          </Button>
                        ) : (
                          <Button
                            bg="inherit"
                            _hover={{ bg: "inherit" }}
                            color="white"
                            fontSize="14px"
                            // mr="10px"
                            onClick={() => setIsOpen7(!isOpen7)}
                          >
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 18 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M8.29688 0.5625H9.70312C9.82812 0.5625 9.89062 0.625 9.89062 0.75V17.25C9.89062 17.375 9.82812 17.4375 9.70312 17.4375H8.29688C8.17187 17.4375 8.10938 17.375 8.10938 17.25V0.75C8.10938 0.625 8.17187 0.5625 8.29688 0.5625Z"
                                fill="white"
                              />
                              <path
                                d="M1.125 8.10938H16.875C17 8.10938 17.0625 8.17187 17.0625 8.29688V9.70312C17.0625 9.82813 17 9.89062 16.875 9.89062H1.125C1 9.89062 0.9375 9.82813 0.9375 9.70312V8.29688C0.9375 8.17187 1 8.10938 1.125 8.10938Z"
                                fill="white"
                              />
                            </svg>
                          </Button>
                        )}
                      </Flex>
                    }
                  </Flex>
                  <Flex
                    height="78vh"
                    width={{ base: "98%", md: "100%" }}
                    flexDir="row"
                    justifyContent="space-between"
                    p="10px"
                    // mt="10px"
                  >
                    <ReactFlow
                      nodes={nodes}
                      edges={edges}
                      proOptions={{ hideAttribution: true }}
                      onNodeClick={
                        captureElementClick ? onNodeClick : undefined
                      }
                      onNodeMouseEnter={
                        captureElementClick ? onNodeMouseEnter : undefined
                      }
                      onNodeMouseLeave={
                        captureElementClick ? onNodeMouseLeave : undefined
                      }
                      onConnect={onConnect}
                      onEdgeUpdate={onEdgeUpdate}
                      onEdgeUpdateStart={onEdgeUpdateStart}
                      onEdgeUpdateEnd={onEdgeUpdateEnd}
                      style={{ fontWeight: "700" }}
                      fitView={true}
                      panOnScroll={true}
                    >
                      <Flex mt="2" padding="12px" width="100px">
                        <Slider
                          defaultValue={sliderValue}
                          min={-40}
                          max={60}
                          step={20}
                          zIndex="1000"
                          aria-label="slider-ex-3"
                          orientation="vertical"
                          minH="40"
                          onChange={handleSlider}
                          onMouseEnter={() => setShowTooltip(true)}
                          onMouseLeave={() => setShowTooltip(false)}
                        >
                          <SliderTrack>
                            <Box position="relative" right={10} />
                            <SliderFilledTrack bg="#C3962C" />
                          </SliderTrack>
                          <Tooltip
                            hasArrow
                            bg="#444d54"
                            color="white"
                            placement="right"
                            isOpen={showTooltip}
                            label={`${100 + sliderValue}%`}
                          >
                            <SliderThumb boxSize={5} bg="#C3962C" />
                          </Tooltip>
                        </Slider>
                        {hoveredNode && (
                          <Flex
                            bg="#444d54"
                            minWidth="350px"
                            padding="12px"
                            color="white"
                            fontSize="16px"
                            flexDirection="column"
                            // borderRadius="5px"
                            float="right"
                            zIndex="10000"
                            right="0"
                            // mt="10px"
                            position="absolute"
                          >
                            <Text>
                              {hoveredNode &&
                                `Title:  ${hoveredNode.data.label}`}
                            </Text>
                            <Text>
                              {hoveredNode
                                ? `Author:  ${hoveredNode.data.author}`
                                : ""}
                            </Text>
                            <Text>
                              {hoveredNode
                                ? `Files:  ${
                                    hoveredNode.data.files.length > 0
                                      ? hoveredNode.data.files.toString()
                                          .length > 50
                                        ? hoveredNode.data.files
                                            .toString()
                                            .substring(0, 50) + "..."
                                        : hoveredNode.data.files.toString()
                                      : "NONE"
                                  }`
                                : ""}
                            </Text>
                          </Flex>
                        )}
                      </Flex>

                      <MiniMap
                        style={{ height: "120", width: "220", zIndex: "1000" }}
                        nodeStrokeWidth={3}
                        zoomable
                        nodeBorderRadius={5}
                        nodeColor={nodeColor}
                        pannable
                        maskStrokeColor="rgb(0,0,0, 0.4)"
                        maskColor="rgb(0,0,0, 0.1)"
                      />
                      <Background />
                      <Controls />
                    </ReactFlow>
                    <Flex
                      width={isOpen7 ? "30vw" : "0"}
                      transition="all 0.3s ease"
                      flexDir="column"
                      overflow="auto"
                      // mt="10px"
                      mt="-48px"
                      pl="10px"
                    >
                      <Flex flexDir="column" ml="2">
                        <Flex
                          color="background.yellow"
                          fontSize="23px"
                          fontWeight="700"
                          justifyContent="space-between"
                        >
                          Description
                          <Flex></Flex>
                        </Flex>

                        <Text
                          color="main.grey1"
                          fontSize="17px"
                          fontWeight="500"
                          ml={1}
                        >
                          {projectInfo.description
                            ? projectInfo.description
                            : "No description provided."}
                        </Text>
                      </Flex>
                      <Flex flexDir="row" m={2} justifyContent="space-between">
                        <Text
                          color="white"
                          fontSize="23px"
                          position="sticky"
                          fontWeight="700"
                        >
                          Reviews
                          {isCollab ? null : (
                            <>
                              <Text
                                ml={5}
                                display="inline-flex"
                                color="white"
                                fontSize="16px"
                                onClick={onOpen}
                                cursor="pointer"
                                bg="#3D454C"
                                p={2}
                                borderRadius="5px"
                              >
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M8.29688 0.5625H9.70312C9.82812 0.5625 9.89062 0.625 9.89062 0.75V17.25C9.89062 17.375 9.82812 17.4375 9.70312 17.4375H8.29688C8.17187 17.4375 8.10938 17.375 8.10938 17.25V0.75C8.10938 0.625 8.17187 0.5625 8.29688 0.5625Z"
                                    fill="white"
                                  />
                                  <path
                                    d="M1.125 8.10938H16.875C17 8.10938 17.0625 8.17187 17.0625 8.29688V9.70312C17.0625 9.82813 17 9.89062 16.875 9.89062H1.125C1 9.89062 0.9375 9.82813 0.9375 9.70312V8.29688C0.9375 8.17187 1 8.10938 1.125 8.10938Z"
                                    fill="white"
                                  />
                                </svg>
                              </Text>
                            </>
                          )}
                        </Text>
                      </Flex>
                      <Box width>
                        {reviews?.map(
                          (review) =>
                            projectInfo && (
                              <Box
                                key={review.id}
                                pr={4}
                                pl={4}
                                pb={4}
                                mb={5}
                                bg={"background.grey3"}
                                borderRadius="10PX"
                                shadow="md"
                              >
                                <Flex
                                  justifyContent={"space-between"}
                                  // py={0}
                                  mb={4}
                                  alignItems={"center"}
                                  color={"gray.500"}
                                >
                                <Flex
                                   justifyContent="flex-start"
                                              flexDir={"row"}
                                      alignItems="center"
                                      fontSize={"13px"}
                                      color={"gray.300"}
                                      mt={1}>
                                      
                                  

                                  
                                  <Avatar
                                                size="sm"
                                                bg="white"
                                                key={id}
                                                name={review.reviewer.name}
                                                src={review.reviewer.name}
                                                color="#2D3842"
                                                fontWeight="300"
                                                mr={1}
                                                // mt={-0.5}
                                                verticalAlign="center"
                                               mt={3}
                                                border="1px solid #2D3842"
                                              />
                                              <Flex
                                              justifyContent="flex-start"
                                              flexDir={"column"}
                                      alignItems="left"
                                      fontSize={"13px"}
                                      color={"gray.300"}
                                      mt={1}>

                                              
                                    <Flex
                                      // justifyContent="flex-start"
                                      alignItems="flex-start"
                                      fontSize={"13px"}
                                      color={"gray.300"}
                                      mt={1}
                                      width={"10vw"}
                                    >
                                   
                                    
                                      {review.reviewer.name.length > 15
                                        ? review.reviewer.name.substring(
                                            0,
                                            15
                                          ) + "..."
                                        : review.reviewer.name}
                                        </Flex>
                                          <Flex justifyContent="flex-start"
                                      alignItems="center"
                                      fontSize={"13px"}
                                      color={"gray.300"}
                                      mt={1}>
                                      <Rating rating={review.rating} />
                                      </Flex>
                                      </Flex>
                                      </Flex>
                                  <Flex
                                    width={"100%"}
                                    flexDir={"row"}
                                    justifyContent={"flex-end"}
                                    alignItems={"center"}
                                    ml={"auto"}
                                  >
                                    <Text
                                      pr={1}
                                      _hover={{
                                        color: "gray.300",
                                      }}
                                    >
                                      <BsFillReplyFill
                                        mx={2}
                                        px={4}
                                        bg={"gray.300"}
                                        cursor={"pointer"}
                                        onClick={() => {
                                          onOpenReplyShow();
                                          setId(review.id);
                                        }}
                                      />
                                    </Text>
                                    {review?.is_author ? (
                                      <>
                                        <Text
                                          pr={1}
                                          _hover={{
                                            color: "gray.300",
                                          }}
                                        >
                                          <BsPencilSquare
                                            mx={1}
                                            px={4}
                                            bg={"gray.300"}
                                            cursor={"pointer"}
                                            onClick={onOpen2}
                                          />
                                        </Text>
                                        <Popover>
                                          <PopoverTrigger>
                                            <Text
                                              _hover={{
                                                color: "gray.300",
                                              }}
                                            >
                                              <BsTrash
                                                mx={2}
                                                px={4}
                                                bg={"gray.300"}
                                                cursor={"pointer"}
                                              />
                                            </Text>
                                          </PopoverTrigger>
                                          <PopoverContent
                                            bg="grey3"
                                            color="white"
                                          >
                                            <PopoverArrow />
                                            <PopoverCloseButton />
                                            <PopoverHeader>
                                              Confirmation!
                                            </PopoverHeader>
                                            <PopoverBody>
                                              <Text>
                                                Are you sure about this?
                                              </Text>
                                              <Button
                                                colorScheme="red"
                                                width="160px"
                                                height="40px"
                                                p="10px"
                                                fontSize="14px"
                                                mr="10px"
                                                mt="20px"
                                                onClick={() =>
                                                  deleteReview(review.id)
                                                }
                                              >
                                                Delete this Review
                                              </Button>
                                            </PopoverBody>
                                          </PopoverContent>
                                        </Popover>
                                      </>
                                    ) : null}
                                  </Flex>
                                </Flex>
                                <Text color="white">{review.comment}</Text>
                                <Flex
                                  color={"gray.500"}
                                  justifyContent={"space-between"}
                                  alignItems={"center"}
                                >
                                  <Text
                                    fontWeight={600}
                                    fontSize={"sm"}
                                    color={"gray.500"}
                                    width={"100%"}
                                  >
                                 
                                    <Divider
                                      orientation="horizontal"
                                      style={{
                                        border:
                                          "1px solid  rgba(255, 255, 255, 0.44)",
                                        marginTop: "2%",
                                      }}
                                    />

                                    { (loadMore === false || review.id!==id ) && review.replies[0] ? (
                                      <>
                                        <Text
                                          color="white"
                                          fontSize="15px"
                                          lineHeight="1.4"
                                          fontWeight="500"
                                          mt={4}
                                        >
                                          {review.replies[0].comment}
                                        </Text>

                                        <Text
                                          color="rgba(255, 255, 255, 0.74)"
                                          p="2px"
                                          borderRadius="10px"
                                          width="fit-content"
                                          pr="5px"
                                          fontSize="12px"
                                          lineHeight="1.4"
                                          fontWeight="700"
                                          mt="5px"
                                          mb="10px"
                                        >
                                          <Avatar
                                                size="xs"
                                                bg="white"
                                                key={id}
                                                name={review.replies[0].author.name}
                                                src={review.replies[0].author.name}
                                                color="#2D3842"
                                                fontWeight="300"
                                                mr={1}
                                                // mt={-0.9}
                                                verticalAlign="center"
                                                border="1px solid #2D3842"
                                              /> {review.replies[0].author.name},{" "}
                                          <ReactTimeAgo
                                            date={review.replies[0].created_on}
                                            locale="en-US"
                                          />
                                          .
                                        </Text>
                                      </>
                                    ) : null}

                                    {loadMore && review.id === id
                                      ? review.replies.map((a) => (
                                          <>
                                            <Text
                                              color="white"
                                              fontSize="15px"
                                              lineHeight="1.4"
                                              fontWeight="500"
                                              mt={4}
                                            >
                                              {a.comment}
                                            </Text>

                                            <Flex
                                              // justifyContent="space-between"
                                              alignItems="center"
                                              height="fit-content"
                                              
                                            >
                                              <Avatar
                                                size="xs"
                                                bg="white"
                                                key={id}
                                                name={a.author.name}
                                                src={a.author.name}
                                                color="#2D3842"
                                                fontWeight="300"
                                                mr={1}
                                                border="1px solid #2D3842"
                                              />
                                              <Text color="rgba(255, 255, 255, 0.74)"
                                              p="2px"
                                              // style={{display:'inline'}}
                                              borderRadius="10px"
                                              width="fit-content"
                                              pr="2px"
                                              fontSize="12px"
                                              lineHeight="1.4"
                                              fontWeight="700"
                                              mt="7px"
                                              mb="10px">
                                                <Text>{a.author.name},{" "}
                                                <ReactTimeAgo
                                                  date={a.created_on}
                                                  locale="en-US"
                                                />
                                                .</Text>
                                                
                                              </Text>
                                            </Flex>

                                            {/* <Text
                                              color="rgba(255, 255, 255, 0.74)"
                                              p="2px"
                                              // style={{display:'inline'}}
                                              borderRadius="10px"
                                              width="fit-content"
                                              pr="5px"
                                              fontSize="12px"
                                              lineHeight="1.4"
                                              fontWeight="700"
                                              mt="4px"
                                              mb="10px"
                                            >
                                              <Avatar
                                                size="xs"
                                                bg="white"
                                                name={a.author.name}
                                                src={a.author.name}
                                                color="#2D3842"
                                                fontWeight="700"
                                                // style={{display:'inline'}}
                                                // mr={2}
                                                align={"center"}
                                              />
                                              <Text
                                                style={{ display: "inline" }}
                                                mt={5}
                                              >
                                                {" "}
                                                {a.author.name},{" "}
                                                <ReactTimeAgo
                                                  date={a.created_on}
                                                  locale="en-US"
                                                />
                                                .
                                              </Text>
                                            </Text> */}
                                          </>
                                        ))
                                      : null}

                                    {review.replies[1] ? (
                                      <>
                                        <Text
                                          _hover={{ cursor: "pointer" }}
                                          style={{
                                            textDecoration: "underline",
                                            color: "white",
                                          }}
                                          onClick={() => {
                                            loadMoreFunc();
                                            setId(review.id);
                                          }}
                                        >
                                          {loadMore!==false && review.id===id?<>hide</>:<>load more</>}
                                        </Text>
                                      </>
                                    ) : (
                                      <Text align="center" mt={1}>Add a Reply</Text>
                                    )}

                                    
                                  </Text>
                                </Flex>
                              </Box>
                            )
                        )}
                      </Box>
                    </Flex>
                  </Flex>
                </Flex>
              </Flex>
            </>
          ) : (
            <Spinner />
          )}
        </Flex>
      </Flex>
      <>
        <Modal isOpen={isOpen} onClose={onClose} isCentered>
          <ModalOverlay />
          <ModalContent bg="background.grey3" color="white">
            <ModalHeader>Tell us how you feel?</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Text fontWeight="500" fontSize="18px" mb="5px">
                Add Review
              </Text>
              <InputGroup width="95%" my={4}>
                <InputLeftElement pointerEvents="none" />
                <Textarea
                  onChange={handleSearchChange}
                  placeholder="Write the description of your review here"
                  color="white"
                />
              </InputGroup>
              <Text fontWeight="500" fontSize="18px" mb="5px">
                Add Rating
              </Text>
              <Flex
                fontSize={"xl"}
                color={"gray.400"}
                width="100%"
                m="auto"
                my={2}
              >
                <Rating
                  rating={currRating.current}
                  displayReviewCount={true}
                  updateRating={true}
                  setRating={ratingHandler}
                />
              </Flex>
            </ModalBody>

            <ModalFooter>
              <Button
                bg="background.yellow1"
                mr={3}
                color="white"
                onClick={() =>
                  reviewHandler("POST", currRating.current, search)
                }
              >
                Add Review
              </Button>
              <Button variant="ghost" onClick={onClose}>
                Cancel
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
      <>
        <Modal isOpen={isOpen2} onClose={onClose2} isCentered>
          <ModalOverlay />
          <ModalContent bg="grey3" color="white">
            <ModalHeader>Edit Review</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Text fontWeight="500" fontSize="18px" mb="5px">
                Edit Description
              </Text>
              <InputGroup width="95%" my={4}>
                <InputLeftElement pointerEvents="none" />
                <Textarea
                  onChange={handleSearchChange}
                  defaultValue={currDesc.current}
                  placeholder="Write the description of your review here"
                  color="white"
                />
              </InputGroup>
              <Text fontWeight="500" fontSize="18px" mb="5px">
                Edit Rating
              </Text>
              <Flex
                fontSize={"xl"}
                color={"gray.400"}
                width="100%"
                m="auto"
                my={2}
              >
                <Rating
                  rating={currRating.current}
                  displayReviewCount={true}
                  updateRating={true}
                  setRating={ratingHandler}
                />
              </Flex>
            </ModalBody>

            <ModalFooter>
              <Button
                bg="yellow1"
                mr={3}
                color="white"
                onClick={() => reviewHandler("PUT", currRating.current, search)}
              >
                Submit
              </Button>
              <Button variant="ghost" onClick={onClose2}>
                Cancel
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
        <Modal isOpen={isOpenReplyShow} onClose={onCloseReplyShow} isCentered>
          <ModalOverlay />
          <ModalContent bg="background.grey3" color="white">
            <ModalHeader>Reply</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              {/* {reviews?.map(
                (review) =>
                  projectInfo &&
                  review.id === id && (
                    <Box key={review.id} p={4} mb={5} shadow="md">
                      <Flex
                        color={"gray.500"}
                        justifyContent={"space-between"}
                        alignItems={"center"}
                      >
                        <Text
                          fontWeight={600}
                          fontSize={"sm"}
                          color={"gray.500"}
                          width={"100%"}
                        >
                          <Flex
                            fontSize={"md"}
                            color={"gray.300"}
                            flexDir="column"
                            width="100%"
                          >
                            {review.replies?.map((a) => (
                              <>
                                <Flex
                                  flexDir="column"
                                  bg
                                  mt={3}
                                  mb={4}
                                  justifyContent="space-between"
                                  borderBottom="2px solid  rgba(255, 255, 255, 0.24)"
                                >
                                  <Text
                                    color="white"
                                    fontSize="20px"
                                    fontWeight="900"
                                  >
                                    {a.comment}
                                  </Text>
                                  <Text
                                    color="rgba(255, 255, 255, 0.74)"
                                    p="2px"
                                    borderRadius="10px"
                                    width="fit-content"
                                    pr="5px"
                                    fontSize="12px"
                                    lineHeight="1.4"
                                    fontWeight="700"
                                    mt="2px"
                                    mb="10px"
                                  >
                                    By {a.author.name},{" "}
                                    <ReactTimeAgo
                                      date={a.created_on}
                                      locale="en-US"
                                    />
                                    .
                                  </Text>
                                </Flex>
                              </>
                            ))}

                           
                          </Flex>
                        </Text>
                      </Flex>
                    </Box>
                  )
              )} */}
              <InputGroup width="95%" my={4}>
                <InputLeftElement pointerEvents="none" />
                <Textarea
                  onChange={handleSearchChange}
                  placeholder="Write the reply to the review here"
                  color="white"
                />
              </InputGroup>
            </ModalBody>

            <ModalFooter>
              <Button
                bg="background.yellow1"
                mr={3}
                color="white"
                onClick={() => postReplies(search, id)}
              >
                Submit
              </Button>
              <Button variant="ghost" onClick={onCloseReply}>
                Cancel
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
        <Modal isOpen={isOpenReply} onClose={onCloseReply} isCentered>
          <ModalOverlay />
          <ModalContent bg="grey3" color="white">
            <ModalHeader>Reply to this review Review</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Text fontWeight="500" fontSize="18px" mb="5px">
                Reply
              </Text>
              <InputGroup width="95%" my={4}>
                <InputLeftElement pointerEvents="none" />
                <Textarea
                  onChange={handleSearchChange}
                  defaultValue={currDesc.current}
                  placeholder="Write the reply to the review here"
                  color="white"
                />
              </InputGroup>

              {/* <Flex
                fontSize={"xl"}
                color={"gray.400"}
                width="100%"
                m="auto"
                my={2}
              >
                <Rating
                  rating={currRating.current}
                  displayReviewCount={true}
                  updateRating={true}
                  setRating={ratingHandler}
                />
              </Flex> */}
            </ModalBody>

            <ModalFooter>
              <Button
                bg="yellow1"
                mr={3}
                color="white"
                onClick={() => postReplies(search, id)}
              >
                Submit
              </Button>
              <Button variant="ghost" onClick={onCloseReply}>
                Cancel
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
      <>
        <Modal bg="#444d54" isOpen={isOpen3} onClose={onClose3} isCentered>
          <ModalOverlay BG="#2A3843" />
          <ModalContent bg="#444d54">
            <ModalHeader color="white">Change Project Owner</ModalHeader>
            <ModalBody>
              <Flex flexDir="column" mb="10px">
                <Text
                  color="white"
                  fontWeight="700"
                  fontSize="18px"
                  mb="5px"
                  mt="15px"
                >
                  New Project Owner Email Address
                </Text>
                <Input
                  bg="#525C64"
                  color="white"
                  fontWeight="700"
                  placeholder="Enter Email Address"
                  ref={newOwner}
                ></Input>
              </Flex>
            </ModalBody>

            <ModalFooter mt="10px">
              <Button
                bg="yellow1"
                color="white"
                mr={3}
                onClick={newOwnerHandler}
              >
                Update New Owner
              </Button>
              <Button color="white" variant="ghost" onClick={onClose3}>
                Cancel
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
      <>
        <Modal isOpen={isOpen5} onClose={onClose5} isCentered>
          <ModalOverlay />
          <ModalContent bg="grey3" color="white">
            <ModalHeader>Add Clients</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Text fontWeight="700" fontSize="18px" mb="5px">
                Current Clients
              </Text>
              <Text fontWeight="700" color="green" fontSize="14px" mb="15px">
                {clients &&
                  clients?.map((client) => {
                    return (
                      client !== " " && (
                        <Flex
                          flexDir="row"
                          py="3px"
                          justifyContent="space-between"
                          height="fit-content"
                        >
                          <Text>{client}</Text>
                          <Text
                            color="gray"
                            border="0.5px solid gray"
                            py="0.5px"
                            px="6px"
                            cursor="pointer"
                            onClick={() => clientRemoveHandler(client)}
                          >
                            X
                          </Text>
                        </Flex>
                      )
                    );
                  })}
              </Text>
              <Select placeholder="Select email" ref={emailView}>
                {dropdownClients
                  ? dropdownClients.map((d, id) => (
                      <option value={d}>{d}</option>
                    ))
                  : null}
              </Select>
            </ModalBody>

            <ModalFooter>
              <Button bg="yellow1" mr={3} onClick={clientHandler} color="white">
                Add Client
              </Button>
              <Button variant="ghost" onClick={onClose5}>
                Cancel
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
      <>
        <Modal isOpen={isOpen4} onClose={onClose4} isCentered>
          <ModalOverlay />
          <ModalContent bg="grey3" color="white">
            <ModalHeader>Add Collaborator</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Text fontWeight="700" fontSize="18px" mb="5px">
                Current Collaborators
              </Text>

              <Text fontWeight="700" color="green" fontSize="14px" mb="15px">
                {collabs &&
                  collabs.split(",").map((collab) => {
                    return (
                      collab !== " " && (
                        <Flex
                          flexDir="row"
                          py="3px"
                          justifyContent="space-between"
                          height="fit-content"
                        >
                          <Text>{collab}</Text>
                          <Text
                            color="gray"
                            border="0.5px solid gray"
                            py="0.5px"
                            px="6px"
                            cursor="pointer"
                            onClick={() => collabRemoveHandler(collab)}
                          >
                            X
                          </Text>
                        </Flex>
                      )
                    );
                  })}
              </Text>
              <Select placeholder="Select email" ref={emailA}>
                {dropdownCollaborators
                  ? dropdownCollaborators.map((d, id) => (
                      <option value={d}>{d}</option>
                    ))
                  : null}
              </Select>
            </ModalBody>

            <ModalFooter>
              <Button bg="yellow1" mr={3} onClick={collabHandler} color="white">
                Add Collaborator
              </Button>
              <Button variant="ghost" onClick={onClose4}>
                Cancel
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
      <>
        <Modal bg="#444d54" isOpen={isOpen6} onClose={onClose6} isCentered>
          <ModalOverlay BG="#2A3843" />
          {projectInfo ? (
            <ModalContent bg="#444d54">
              <ModalHeader color="white">Edit Template</ModalHeader>
              <ModalBody>
                <Flex flexDir="column" mb="10px">
                  <Text
                    color="white"
                    fontWeight="700"
                    fontSize="18px"
                    mb="5px"
                    mt="15px"
                  >
                    Project Title
                  </Text>
                  <Input
                    bg="#525C64"
                    color="white"
                    fontWeight="400"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                  ></Input>
                </Flex>
                <Flex flexDir="column">
                  <Text color="white" fontWeight="700" fontSize="18px" mb="5px">
                    Industry
                  </Text>
                  <Select
                    bg="#525C64"
                    color="white"
                    value={industry}
                    fontWeight="400"
                    onChange={(e) => setIndustry(e.target.value)}
                  >
                    <option value="Financial Services">
                      Financial Services
                    </option>
                    <option value="Healthcare">Healthcare</option>
                    <option value="Retail">Retail</option>
                    <option value="Technology">Technology</option>
                    <option value="Government">Government</option>
                    <option value="Legal">Legal</option>
                    <option value="Other">Other</option>
                  </Select>
                </Flex>
                {/* <Flex flexDir="column">
                  <Text
                    color="white"
                    fontWeight="700"
                    fontSize="18px"
                    mb="5px"
                    mt="15px"
                  >
                    Name of the Client
                  </Text>
                  <Input
                    bg="#525C64"
                    color="white"
                    fontWeight="700"
                    value={client}
                    onChange={(e) => setClient(e.target.value)}
                  ></Input>
                </Flex> */}
                <Flex flexDir="column">
                  <Text
                    color="white"
                    fontWeight="700"
                    fontSize="18px"
                    mb="5px"
                    mt="15px"
                  >
                    Project Code
                  </Text>
                  <Input
                    bg="#525C64"
                    color="white"
                    fontWeight="400"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                  ></Input>
                </Flex>
                {/* <Flex flexDir="column">
                  <Text
                    color="white"
                    fontWeight="700"
                    fontSize="18px"
                    mb="5px"
                  >
                    Visibility
                  </Text>
                  <Select
                    bg="#525C64"
                    color="white"
                    value={visibility}
                    onChange={(e) => setVisibility(e.target.value)}
                    fontWeight="700"
                  >
                    <option value="public">Public</option>
                    <option value="private">Private</option>
                  </Select>
                </Flex> */}
                <Flex flexDir="column">
                  <Text
                    color="white"
                    fontWeight="700"
                    fontSize="18px"
                    mb="5px"
                    mt="15px"
                  >
                    Description
                  </Text>
                  <Textarea
                    value={stateDescription}
                    bg="#525C64"
                    color="#fefefe"
                    fontWeight="400"
                    // variant="outline"
                    // _focus={{
                    //   border:"0.5px solid white",
                    //   boxShadow: 'none',  // removes the default Chakra UI focus shadow
                    //   outline: 'none',  // removes the browser's default focus outline
                    // }}
                    // border="none"

                    onChange={handleDescriptionChange}
                    placeholder="Enter state description..."
                    mt="15px"
                  />
                </Flex>
              </ModalBody>

              <ModalFooter mt="10px">
                <Button
                  bg="yellow1"
                  color="white"
                  mr={3}
                  onClick={editProjectHandler}
                >
                  Edit Template
                </Button>
                <Button color="white" variant="ghost" onClick={onClose6}>
                  Cancel
                </Button>
              </ModalFooter>
            </ModalContent>
          ) : null}
        </Modal>
      </>
      <>
        <Modal
          isOpen={isOpenAccess}
          onClose={() => {
            setSelectedRole("Select Role");
            onCloseAccess();
          }}
          isCentered
          size="xl"
        >
          <ModalOverlay g="#0000004D" />
          <ModalContent bg="grey3" color="white">
            <ModalHeader fontSize={"2xl"}>
              Share "{projectInfo?.title}"
            </ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Flex flexDir="row" mb={3}>
                <Flex width="69%" flexDir="column">
                  <ReactSearchAutocomplete
                    items={accessList}
                    fuseOptions={{
                      threshold: 0.2,
                      useExtendedSearch: true,
                      findAllMatches: true,
                      distance: 150,
                      ignoreLocation: true,
                    }}
                    showIcon={true}
                    icon={<SearchIcon color="white" />}
                    onSearch={handleOnSearch}
                    onHover={handleOnHover}
                    onSelect={(mail) => {
                      emailA.current = mail.name;
                    }}
                    onFocus={handleOnFocus}
                    autoFocus
                    styling={{
                      display: "block",
                      borderRadius: "5px",
                      backgroundColor: "#646B72",
                      boxShadow: "none",
                      border: "none",
                      placeholderColor: "white",
                      color: "white",
                      iconColor: "white",
                      lineColor: "white",
                      clearIconMargin: "3px 8px 0 0",
                      zIndex: 2,
                      showIcon: false,
                      resultItemHoverStyle: {
                        backgroundColor: "grey", // set the background color on hover to grey
                        color: "white",
                      },
                    }}
                    // formatResult={formatResult}
                    maxResults={5}
                    placeholder="Search for users by email"
                  />
                </Flex>
                <Menu>
                  <MenuButton
                    as={Button}
                    rightIcon={<ChevronDownIcon />}
                    bg="yellow1"
                    color="white"
                    height="44px"
                    ml={3}
                  >
                    {selectedRole}
                  </MenuButton>
                  <MenuList color="grey3">
                    <MenuItem onClick={() => setSelectedRole("Client")}>
                      Client
                    </MenuItem>

                    <MenuItem onClick={() => setSelectedRole("Collaborator")}>
                      Collaborator
                    </MenuItem>
                    <MenuItem onClick={() => setSelectedRole("Owner")}>
                      Owner
                    </MenuItem>
                  </MenuList>
                </Menu>
              </Flex>
              {/* <Text fontWeight="700" fontSize="18px" mb="5px">
                  Current Collaborators
                </Text> */}
              <Text color="#FFFFFFBF" fontWeight="600" fontSize="16px" mt={3}>
                People with access
              </Text>
              <Text fontWeight="700" fontSize="14px" mb="15px">
                <Box maxH="150px" overflowY="auto">
                  {hasAccessList &&
                    hasAccessList.map((user, id) => (
                      <Flex
                        // flexDir="column"
                        flexDir="row"
                        py="3px"
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <Flex
                          justifyContent="space-between"
                          alignItems="center"
                          height="fit-content"
                        >
                          <Avatar
                            size="sm"
                            bg="white"
                            key={id}
                            name={user?.name}
                            src={user?.name}
                            color="#2D3842"
                            fontWeight="300"
                            mr={2}
                            border="1px solid #2D3842"
                          />
                          <Text>
                            <Text>{user?.name}</Text>
                            <Text fontWeight="400" color="grey1">
                              {user?.email} ({user?.role})
                            </Text>
                          </Text>
                        </Flex>
                        {user.role !== "owner" && (
                          <Text
                            mr="6px"
                            color="grey1"
                            fontSize={"md"}
                            cursor="pointer"
                            onClick={() => {
                              user.role === "client" &&
                                clientRemoveHandler(user.email);
                              // user.role === "viewer" && viewerRemoveHandler(user.email);
                              user.role === "collaborator" &&
                                collabRemoveHandler(user.email);
                            }}
                          >
                            <BiTrash />
                          </Text>
                        )}
                      </Flex>
                    ))}
                </Box>
              </Text>
            </ModalBody>

            <ModalFooter>
              <Button
                bg="yellow1"
                mr={3}
                // onClick={accessHandler}
                color="white"
              >
                Add User
              </Button>
              <Button variant="ghost" onClick={onCloseAccess}>
                Cancel
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
    </>
  );
};

export default Template;
